/**
 * What to paint while a campaign or template tab is missing its full record.
 *
 * A failed GET used to leave `!ready` true forever, so the FOKUS loader never
 * left the screen — including tabs restored onto an open doc.
 */
export function detailContentGate({
  ready,
  loadError,
  canReuseLast,
  keepOverlay,
  hasLast,
  isLoadingItem,
}) {
  if (!ready && loadError && !canReuseLast) return 'error';

  const showLoader = (isLoadingItem || !ready) && !(loadError && canReuseLast);
  const canMount = ready || canReuseLast || (keepOverlay && hasLast && !loadError);

  if (!canMount) return 'skeleton';
  return showLoader ? 'loading' : 'ready';
}
